EmailFormBaseView = require "../base_view"
EmailFormUsDateTimeInputView = require "./date_time_input"
EmailFormTextLineInputView = require "../../common/views/text_line_input_view"
EmailFormUSUserContactInfoView = require "./user_contact_info_view"
EmailFormPhoneNumberInputView = require "../../common/views/phone_number_input"
EmailFormUSMerchantLocationInfoView = require "./merchant_location_info_view"
EmailFormUSUserIdentificationView = require "./user_identification_view"
EmailFormUSEmailDescriptionView = require "./email_description_view"
SharedWidgetLayoutView = require "../../../../../shared/frontend/views/widget_layout_veiw"
SupportStepThreeTemplate = require '../../../../step_three.html.mustache'
SupportUSFlexibleEmailFormObjectsTemplate = require '../../../../us_flexible_email_form_objects.html.mustache'

class EmailFormUSMainView extends EmailFormBaseView
  events:
    'click .submit-button': 'onSubmitClick'

  initialize: (options)->
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    EmailFormBaseView::initialize.apply(this, arguments)
    @template = SupportStepThreeTemplate
    @model = options.emailFormModel
    @inputObjects = @model.getEmailFormInputObjects()

  render: ->
    SharedWidgetLayoutView.hideWidgets()
    @renderEmailForm()
    this

  contactByEmail: ->
    @renderEmailForm()

  renderEmailForm: () ->
    @hideComponents()
    @$el.html(toHtml(@template, @toHash(), @I18nScope))
    @renderInputViews(@inputObjects, "#componentList")
    @renderStepActions()
    @validateEmailForm()
    this

  getViewByObjectType: (obj) ->
    options =
      model: obj
      validateEmailForm: @validateEmailForm
      template: SupportUSFlexibleEmailFormObjectsTemplate

    switch obj.type
      when 'user_identification' then new EmailFormUSUserIdentificationView options
      when 'merchant_location'
        options.model = _.extend obj, {numberOfRedemptionLocations: @model.numberOfRedemptionLocationsAvailable()}
        new EmailFormUSMerchantLocationInfoView options
      when 'user_contact_info' then new EmailFormUSUserContactInfoView options
      when 'description'       then new EmailFormUSEmailDescriptionView options
      when 'text_field_line'   then new EmailFormTextLineInputView options
      when 'phone_number'      then new EmailFormPhoneNumberInputView options
      when 'date_time'         then new EmailFormUsDateTimeInputView options
      when 'calendar_with_hour_slot'  then new EmailFormUsDateTimeInputView options

  toHash: ->
    if window.liveChatInfo?.mode?.step_three? then mode = window.liveChatInfo.mode.step_three
    hash =
      reason                   : @getIssueReason()
      is_order                 : Groupon.Support.currentOrder?
      show_reason              : !@model.isDummyCategory
      merchant_name            : getDealMerchantName()
      faqInsteadHelpWizard     : window.faqInsteadHelpWizard
      show_all_fields_required : !@model.isFTRDropdownCombinationSlected()

  getFormData: ->
    data = EmailFormBaseView::getFormData.apply(this, arguments)
    data.flexible_form = if window.evaluate(experiments?.flexStepThreeForUS) then experiments.flexStepThreeForUS else false
    data.NLPSearchQuery = Groupon.Support.ContentModel.getSearchInputIssue()
    data

  getChatParams: () ->
    params =
      issue: @getIssueReason()

  getIssueReason: () ->
    Groupon.Support.ContentModel.getSearchInputIssue() || @model.reasonText

  remove: ->
    # Ideally we should destroy all child views to prevent dangling references to those views.
    $('.xdsoft_datetimepicker').remove()
    EmailFormBaseView::remove.call(this)

  close: ->
    #nothing to close for now

  isPhonePreferredChannel: ()->
    false

module.exports = EmailFormUSMainView
